class PopUpDC {
  //렌딩 페이지 오픈카카오톡 모달
  public COOKIE_VALUE = 'never-show-oneday';
  //케이스 QNA 게시판 모달
  public CASE_QNA_COOKIE_VALUE = 'never-show-oneday-caseqna';
  //케이스노트 소개모달
  public CASE_NOTE_INTRODUCTION_COOKIE_VALUE = 'never-show-oneday-case-note-introduction';
  //케이스 노트 인증 만료 시간(문자인증하고 한시간)
  public CASE_NOTE_AUTHENTICATION_COOKIE_VALUE = 'case-note-authentication';
  //랜딩 페이지 프레임워크 소개 모달
  public FRAMEWORK_INFO_COOKIE_VALUE = 'never-show-oneday-framework-info';
  // 퀴즈 연장 결제 모달
  public EXTEND_QUIZ_SUBCRIBTION_COOKIE_VALUE = 'nerver-show-remain-date';
}

//DC를 인스턴스로 쓸 수 있게 new PopUpDC()로 export
export default new PopUpDC();
